// extracted by mini-css-extract-plugin
export default {"unread-messages":"unread-messages--117rE","icon":"icon--2BHwe"};